
import httpClient from "@/plugins/axios";


export const getChannels = async () => {
    const response = await httpClient.get(`/v1/chat/channels/`);
    return response;
}

export const getManagedChannels = async () => {
    const response = await httpClient.get(`/v1/chat/channels/managed/?v2=true`);
    return response;
}

export const getChannel = async (id) => {
    const response = await httpClient.get(`/v1/chat/channels/${id}/`);
    return response;
}

export const getChannelRooms = async (id) => {
    const response = await httpClient.get(`/v1/chat/channels/${id}/rooms/`);
    return response;
}

export const getChannelRoom = async (channelId) => {
    const response = await httpClient.get(`/v1/chat/rooms/${channelId}/`);
    return response;
}

export const getChannelRoomForUser = async (channelId, userId) => {
    const response = await httpClient.get(`/v1/chat/rooms/${channelId}/user/${userId}`);
    return response;
}

export const authenticateChatRoom = async (chatroomKey) => {
    const response = await httpClient.post(`/v1/chat/authenticate/`,
        {
            room_key: chatroomKey
        });
    return response;
}

export const deleteChatMessage = async (channelId, chatroomKey, messageId) => {
    const response = await httpClient.delete(`v1/chat/channels/${channelId}/rooms/${chatroomKey}/messages/${messageId}/`);
    return response;
}